import styled from 'styled-components'
import { maxXs } from '../../styles/breakPoints'

export const Footer = styled.footer`
  display: flex;
  flex: 0 0 auto;
  justify-content: space-evenly;
  width: 100%;
  padding-top: 120px;
  padding-bottom: 120px;
  background-color: #fff5e6;

  @media (${maxXs}) {
    flex-direction: column;
    padding-bottom: 60px;

    padding-left: 20px;
    padding-right: 20px;
  }

  img {
    width: 68px;
    margin-bottom: 10px;
  }

  .left {
    display: flex;
    flex-direction: column;

    a {
      display: flex;
      flex-direction: column;
      text-decoration: none;
      margin-bottom: 20px;

      @media (${maxXs}) {
        align-items: center;
        margin-bottom: 10px;
      }
    }

    @media (${maxXs}) {
      align-items: center;
      margin-bottom: 30px;
    }
  }

  .right {
    display: flex;
    flex-direction: row;

    h3 {
      margin-bottom: 10px;
    }

    div {
      display: flex;
      flex-direction: column;
      margin-right: 35px;

      @media (${maxXs}) {
        margin-right: 0px;
      }
    }

    a.margin {
      margin-bottom: 5px;
    }

    @media (${maxXs}) {
      justify-content: space-between;
    }

    .social {
      @media (${maxXs}) {
        display: grid;
        grid-template-columns: 1fr 1fr;

        span {
          margin-right: 10px;
        }
      }
    }
  }

  span {
    font-family: proxima-nova;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    text-align: left;
    color: #222222;
  }

  a {
    text-decoration: none;
  }

  button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }

  .languages {
    margin-bottom: 20px;
  }
`
